import { axiosInstance } from '@/rest'

const createBrokerApi = () => {
  return {
    getById: (brokerId) => {
      return axiosInstance
        .get(`utils/brokers?broker_id=${brokerId}`)
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return null
          }
        })
    },
  }
}

const brokerApi = createBrokerApi()

export { brokerApi }
